import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
  })
export class HttpIntercept implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const modified = req.clone();
        if (req.url.indexOf('SendTranscationMailBeforePay') > -1) {
            return next.handle(modified).pipe(timeout(1000000));
        } else {
            return next.handle(modified);
        }
    }
}
